import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _ACTIVITY_OPTIONS_BY_;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadVerticals),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(getLocalizedDisplayDistance),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadRadius),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doAddActivityFilter),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadActivity),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadAmenity),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadLevel),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadCredits),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadDate),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadTime),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(getDefaultResultType),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(getResultType),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadResultType),
    _marked14 =
/*#__PURE__*/
regeneratorRuntime.mark(doSetupFilters),
    _marked15 =
/*#__PURE__*/
regeneratorRuntime.mark(watchFilters);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { setActivityKeyword } from 'features/Search/SearchBox/SearchBox.saga';
import { defineMessages } from 'react-intl';
import { selectMeasurementSystem } from 'redux/modules/locale';
import { isLoggedIn } from 'redux/modules/user';
import { deepExtract } from 'helpers/deep';
import { distanceInMiles } from 'helpers/distance';
import { filterSetFilters } from 'redux/saga/selectors';
import { SEARCH } from 'constants/filter-sets';
import { searchFilterActions, selectSearchFilters, initializeMultiSelectFromHash, getDefaultVerticalId, selectSelectedVertical, getCreditsFilterValue } from './filters.helpers';
import { setupFilters, setFilteringDisabled, selectActiveUrl } from '../Search.reducer';
import { selectFiltersFromSearchResults, selectLocationAutocompleteFromSearchResults } from '../Search.helpers';
import { FILTER_NAMES, RESULT_TYPES, AUTO_RADIUS_ID, VERTICALS } from '../Search.constants';
import { selectSelectedKeywordId } from '../SearchBox/SearchBox.reducer';
import { PATH as SEARCH_PATH } from '../Search.route';
import { amenityMessages, levelMessages, radiusMessages } from './filters.messages';
var addFilter = searchFilterActions.addFilter;
var ACTIVITY = FILTER_NAMES.ACTIVITY,
    DATE = FILTER_NAMES.DATE,
    RADIUS = FILTER_NAMES.RADIUS,
    RESULT_TYPE = FILTER_NAMES.RESULT_TYPE,
    TIME = FILTER_NAMES.TIME,
    VERTICAL = FILTER_NAMES.VERTICAL,
    AMENITY = FILTER_NAMES.AMENITY,
    LEVEL = FILTER_NAMES.LEVEL,
    CREDITS = FILTER_NAMES.CREDITS;
var SCHEDULE = RESULT_TYPES.SCHEDULE,
    VENUE = RESULT_TYPES.VENUE;
export var DEFAULT_RESULT_TYPE_LOGGED_IN = SCHEDULE;
export var DEFAULT_RESULT_TYPE_LOGGED_OUT = VENUE;
export var BASE_VERTICALS_OPTIONS = [_objectSpread({
  id: VERTICALS.fitness
}, defineMessages({
  name: {
    id: 'filters.vertical.fitness.name',
    defaultMessage: 'Group Fitness'
  },
  description: {
    id: 'filters.vertical.fitness.description',
    defaultMessage: 'Yoga, boxing, pilates, etc'
  }
})), _objectSpread({
  id: VERTICALS.wellness
}, defineMessages({
  name: {
    id: 'filters.vertical.wellness.name',
    defaultMessage: 'Wellness'
  },
  description: {
    id: 'filters.vertical.wellness.description',
    defaultMessage: 'Massages, meditation, etc.'
  }
})), _objectSpread({
  id: VERTICALS.gym
}, defineMessages({
  name: {
    id: 'filters.vertical.gym.name',
    defaultMessage: 'Gym Time'
  },
  description: {
    id: 'filters.vertical.gym.description',
    defaultMessage: 'Book flexible sessions at the gym'
  }
}))];
export var ALL_VERTICALS_OPTION = _objectSpread({
  id: VERTICALS.all
}, defineMessages({
  name: {
    id: 'filters.vertical.all.name',
    defaultMessage: 'All categories'
  }
}));
export var TIME_DEFAULT = '04:30-23:00';
export var TIME_OPTIONS = [_objectSpread({
  id: '05:00-08:00'
}, defineMessages({
  name: {
    id: 'filters.time.early.name',
    defaultMessage: 'Early Morning'
  },
  description: {
    id: 'filters.time.early.description',
    defaultMessage: '5 am - 8 am'
  }
})), _objectSpread({
  id: '08:00-10:00'
}, defineMessages({
  name: {
    id: 'filters.time.late-morning.name',
    defaultMessage: 'Late Morning'
  },
  description: {
    id: 'filters.time.late-morning.description',
    defaultMessage: '8 am - 10 am'
  }
})), _objectSpread({
  id: '10:00-14:00'
}, defineMessages({
  name: {
    id: 'filters.time.midday.name',
    defaultMessage: 'Midday'
  },
  description: {
    id: 'filters.time.midday.description',
    defaultMessage: '10 am - 2 pm'
  }
})), _objectSpread({
  id: '14:00-17:00'
}, defineMessages({
  name: {
    id: 'filters.time.afternoon.name',
    defaultMessage: 'Afternoon'
  },
  description: {
    id: 'filters.time.afternoon.description',
    defaultMessage: '2 pm - 5 pm'
  }
})), _objectSpread({
  id: '17:00-19:00'
}, defineMessages({
  name: {
    id: 'filters.time.evening.name',
    defaultMessage: 'Evening'
  },
  description: {
    id: 'filters.time.evening.description',
    defaultMessage: '5 pm - 7 pm'
  }
})), _objectSpread({
  id: '19:00-23:00'
}, defineMessages({
  name: {
    id: 'filters.time.late-evening.name',
    defaultMessage: 'Late evening'
  },
  description: {
    id: 'filters.time.late-evening.description',
    defaultMessage: 'After 7 pm'
  }
}))];
export var ACTIVITY_OPTIONS_BY_VERTICAL = (_ACTIVITY_OPTIONS_BY_ = {}, _defineProperty(_ACTIVITY_OPTIONS_BY_, VERTICALS.fitness, [_objectSpread({
  id: 'activity-1'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.1.name',
    defaultMessage: 'Yoga'
  }
})), _objectSpread({
  id: 'activity-553'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.553.name',
    defaultMessage: 'Barre'
  }
})), _objectSpread({
  id: '142'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.142.name',
    defaultMessage: 'HIIT'
  }
})), _objectSpread({
  id: '140'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.140.name',
    defaultMessage: 'Bootcamp'
  }
})), _objectSpread({
  id: 'activity-23'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.23.name',
    defaultMessage: 'Martial arts'
  }
})), _objectSpread({
  id: 'activity-467'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.467.name',
    defaultMessage: 'Rowing'
  }
})), _objectSpread({
  id: 'activity-589'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.589.name',
    defaultMessage: 'Running'
  }
})), _objectSpread({
  id: 'activity-72'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.72.name',
    defaultMessage: 'Cycling'
  }
})), _objectSpread({
  id: 'activity-90'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.90.name',
    defaultMessage: 'Pilates'
  }
})), _objectSpread({
  id: 'activity-100'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.100.name',
    defaultMessage: 'Dance'
  }
})), _objectSpread({
  id: 'activity-587'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.587.name',
    defaultMessage: 'Boxing'
  }
})), _objectSpread({
  id: 'activity-591'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.591.name',
    defaultMessage: 'Outdoors'
  }
})), _objectSpread({
  id: 'activity-590'
}, defineMessages({
  name: {
    id: 'filters.activity.fitness.590.name',
    defaultMessage: 'Sports'
  }
}))]), _defineProperty(_ACTIVITY_OPTIONS_BY_, VERTICALS.wellness, [_objectSpread({
  id: '1145'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1145.name',
    defaultMessage: 'Massage'
  }
})), _objectSpread({
  id: '1147'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1147.name',
    defaultMessage: 'Facial'
  }
})), _objectSpread({
  id: '1149'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1149.name',
    defaultMessage: 'Cryotherapy'
  }
})), _objectSpread({
  id: '1151'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1151.name',
    defaultMessage: 'Sports recovery'
  }
})), _objectSpread({
  id: '1153'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1153.name',
    defaultMessage: 'Sauna'
  }
})), _objectSpread({
  id: '1155'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1155.name',
    defaultMessage: 'Meditation'
  }
})), _objectSpread({
  id: '1157'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1157.name',
    defaultMessage: 'Acupuncture'
  }
})), _objectSpread({
  id: '1159'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1159.name',
    defaultMessage: 'Cupping'
  }
})), _objectSpread({
  id: '1161'
}, defineMessages({
  name: {
    id: 'filters.activity.wellness.1161.name',
    defaultMessage: 'Beauty'
  }
}))]), _ACTIVITY_OPTIONS_BY_);
export var RADIUS_OPTIONS = {
  /* eslint-disable object-curly-newline */
  imperial: [{
    id: 1,
    defineMessage: radiusMessages.half_mile,
    radius: '1/2',
    value: 0.8
  }, {
    id: 2,
    defineMessage: radiusMessages.imperial,
    radius: '1',
    value: 1.6
  }, {
    id: 3,
    defineMessage: radiusMessages.imperial,
    radius: '5',
    value: 8
  }, {
    id: 4,
    defineMessage: radiusMessages.imperial,
    radius: '10',
    value: 16.1
  }, {
    id: 5,
    defineMessage: radiusMessages.imperial,
    radius: '25',
    value: 40.2
  }],
  metric: [{
    id: 6,
    defineMessage: radiusMessages.metric,
    radius: '1',
    value: 1
  }, {
    id: 7,
    defineMessage: radiusMessages.metric,
    radius: '2',
    value: 2
  }, {
    id: 8,
    defineMessage: radiusMessages.metric,
    radius: '5',
    value: 5
  }, {
    id: 9,
    defineMessage: radiusMessages.metric,
    radius: '10',
    value: 10
  }, {
    id: 10,
    defineMessage: radiusMessages.metric,
    radius: '20',
    value: 20
  }]
  /* eslint-enable object-curly-newline */

};
export var AMENITY_OPTIONS = [{
  id: 'shower',
  name: amenityMessages.showers
}, {
  id: 'locker',
  name: amenityMessages.lockers
}, {
  id: 'parking',
  name: amenityMessages.parking
}];
export var LEVEL_OPTIONS = [{
  id: 'level_all',
  name: levelMessages.open
}, {
  id: 'level_beginner',
  name: levelMessages.beginner
}, {
  id: 'level_advanced',
  name: levelMessages.advanced
}];
export var LOAD_VERTICALS = 'LOAD_VERTICALS';
export var LOAD_ACTIVITY = 'LOAD_ACTIVITY';
export var LOAD_AMENITY = 'LOAD_AMENITY';
export var LOAD_LEVEL = 'LOAD_LEVEL';
export var LOAD_DATE = 'LOAD_DATE';
export var LOAD_TIME = 'LOAD_TIME';
export var LOAD_RESULT_TYPE = 'LOAD_RESULT_TYPE';
export var FILTER_CHANGED = 'classpass/search/FILTER_CHANGED';
export var FILTERS_CHANGED = 'classpass/search/FILTERS_CHANGED';
export var EXPAND_RADIUS = 'EXPAND_RADIUS';
export var LOAD_RADIUS = 'LOAD_RADIUS';
export var LOAD_CREDITS = 'LOAD_CREDITS';
export var loadVerticals = function loadVerticals() {
  return {
    type: LOAD_VERTICALS
  };
};
export var loadActivity = function loadActivity() {
  return {
    type: LOAD_ACTIVITY
  };
};
export var loadAmenity = function loadAmenity() {
  return {
    type: LOAD_AMENITY
  };
};
export var loadLevel = function loadLevel() {
  return {
    type: LOAD_LEVEL
  };
};
export var loadDate = function loadDate() {
  return {
    type: LOAD_DATE
  };
};
export var loadTime = function loadTime() {
  return {
    type: LOAD_TIME
  };
};
export var loadResultType = function loadResultType() {
  return {
    type: LOAD_RESULT_TYPE
  };
};
export var filterChanged = function filterChanged(filter) {
  return {
    type: FILTER_CHANGED,
    filter: filter
  };
};
export var filtersChanged = function filtersChanged(filters) {
  return {
    type: FILTERS_CHANGED,
    filters: filters
  };
};
export var loadRadius = function loadRadius() {
  return {
    type: LOAD_RADIUS
  };
};
export var loadCredits = function loadCredits() {
  return {
    type: LOAD_CREDITS
  };
};
export var getActivityOptionsForVerticalId = function getActivityOptionsForVerticalId(verticalId) {
  var _ref;

  return verticalId === VERTICALS.all ? (_ref = []).concat.apply(_ref, _toConsumableArray(Object.values(ACTIVITY_OPTIONS_BY_VERTICAL))) : ACTIVITY_OPTIONS_BY_VERTICAL[verticalId];
};
export var getVerticalOptions = function getVerticalOptions(includeAll) {
  return includeAll ? [ALL_VERTICALS_OPTION].concat(BASE_VERTICALS_OPTIONS) : BASE_VERTICALS_OPTIONS;
};
export function doLoadVerticals() {
  var _ref2, vertical, defaultVerticalId, verticalOptions;

  return regeneratorRuntime.wrap(function doLoadVerticals$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(selectFiltersFromSearchResults);

        case 2:
          _ref2 = _context.sent;
          vertical = _ref2.vertical;
          _context.next = 6;
          return select(getDefaultVerticalId);

        case 6:
          defaultVerticalId = _context.sent;
          verticalOptions = getVerticalOptions(defaultVerticalId === VERTICALS.all);
          _context.next = 10;
          return put(addFilter(VERTICAL, verticalOptions, undefined, {
            exclusive: true,
            value: vertical || defaultVerticalId
          }));

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function getRadiusByItemId(filters, itemId) {
  return deepExtract("".concat(RADIUS, ".itemsById.").concat(itemId, ".value"), filters);
} // Returns a radius only if the user selected one

export function getSelectedRadius(filters) {
  var selectedRadiusId = deepExtract("".concat(RADIUS, ".value"), filters);
  return getRadiusByItemId(filters, selectedRadiusId);
}
export function getLocalizedDisplayDistance(distance) {
  var measurementSystem, usesMetricSystem, localizedDistance;
  return regeneratorRuntime.wrap(function getLocalizedDisplayDistance$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(selectMeasurementSystem);

        case 2:
          measurementSystem = _context2.sent;
          usesMetricSystem = measurementSystem === 'metric';
          localizedDistance = usesMetricSystem ? distance : distanceInMiles(distance); // convert to mi

          return _context2.abrupt("return", localizedDistance.toFixed(1));

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doLoadRadius() {
  var _ref3, _ref4, measurementSystem, locationAutoCompleteFromHash, radiusList, radiusListCopy, defaultDistance, filterOptions;

  return regeneratorRuntime.wrap(function doLoadRadius$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return all([select(selectMeasurementSystem), select(selectLocationAutocompleteFromSearchResults)]);

        case 2:
          _ref3 = _context3.sent;
          _ref4 = _slicedToArray(_ref3, 2);
          measurementSystem = _ref4[0];
          locationAutoCompleteFromHash = _ref4[1];
          radiusList = RADIUS_OPTIONS[measurementSystem]; // Need to create a copy of our radius list to avoid mutating our base radius option lists

          radiusListCopy = radiusList.slice(0);
          defaultDistance = {
            imperial: deepExtract('calculated_radius_miles', locationAutoCompleteFromHash),
            metric: deepExtract('calculated_radius_km', locationAutoCompleteFromHash)
          };
          radiusListCopy.unshift({
            id: AUTO_RADIUS_ID,
            name: radiusMessages.auto,
            defineMessage: radiusMessages[measurementSystem],
            value: defaultDistance.metric,
            selectedDisplayValue: defaultDistance[measurementSystem]
          });
          filterOptions = {
            valueFilter: true,
            value: AUTO_RADIUS_ID,
            unfilteredValue: AUTO_RADIUS_ID // This indicates that the AUTO_RADIUS_ID represents an unfiltered state so the "filtered" state can be set correctly

          };
          _context3.next = 13;
          return put(addFilter(RADIUS, radiusListCopy, undefined, filterOptions));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function doAddActivityFilter(isSelectedByActivityName) {
  var selectedVertical, activities, filterOptions;
  return regeneratorRuntime.wrap(function doAddActivityFilter$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(selectSelectedVertical);

        case 2:
          selectedVertical = _context4.sent;
          activities = getActivityOptionsForVerticalId(selectedVertical);
          filterOptions = {
            selected: isSelectedByActivityName
          };
          _context4.next = 7;
          return put(addFilter(ACTIVITY, activities || [], undefined, filterOptions));

        case 7:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function doLoadActivity() {
  var currentKeywordSelectedId, _ref5, tags, isSelectedByActivityName;

  return regeneratorRuntime.wrap(function doLoadActivity$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return select(selectSelectedKeywordId);

        case 2:
          currentKeywordSelectedId = _context5.sent;
          _context5.next = 5;
          return select(selectFiltersFromSearchResults);

        case 5:
          _ref5 = _context5.sent;
          tags = _ref5.tag;

          if (!(!currentKeywordSelectedId && tags && tags.length === 1)) {
            _context5.next = 10;
            break;
          }

          _context5.next = 10;
          return call(setActivityKeyword, tags[0]);

        case 10:
          isSelectedByActivityName = {}; // If 2 or more tags, we initialize the activity filter with those tags.

          if (tags && tags.length >= 2) {
            isSelectedByActivityName = tags.reduce(function (acc, activity) {
              return _objectSpread({}, acc, _defineProperty({}, activity, true));
            }, {});
          }

          _context5.next = 14;
          return call(doAddActivityFilter, isSelectedByActivityName);

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function doLoadAmenity() {
  var filtersFromHash, amenityKeys, isSelectedByAmenityName, filterOptions;
  return regeneratorRuntime.wrap(function doLoadAmenity$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return select(selectFiltersFromSearchResults);

        case 2:
          filtersFromHash = _context6.sent;
          amenityKeys = ['shower', 'locker', 'parking'];
          isSelectedByAmenityName = initializeMultiSelectFromHash(amenityKeys, filtersFromHash);
          filterOptions = {
            selected: isSelectedByAmenityName
          };
          _context6.next = 8;
          return put(addFilter(AMENITY, AMENITY_OPTIONS, undefined, filterOptions));

        case 8:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
export function doLoadLevel() {
  var filtersFromHash, levelKeys, isSelectedByLevelName, filterOptions;
  return regeneratorRuntime.wrap(function doLoadLevel$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(selectFiltersFromSearchResults);

        case 2:
          filtersFromHash = _context7.sent;
          levelKeys = ['level_all', 'level_beginner', 'level_advanced'];
          isSelectedByLevelName = initializeMultiSelectFromHash(levelKeys, filtersFromHash);
          filterOptions = {
            selected: isSelectedByLevelName
          };
          _context7.next = 8;
          return put(addFilter(LEVEL, LEVEL_OPTIONS, undefined, filterOptions));

        case 8:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
export function doLoadCredits() {
  var filtersFromHash, minCredits, maxCredits, creditsRangeValue, filterOptions;
  return regeneratorRuntime.wrap(function doLoadCredits$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(selectFiltersFromSearchResults);

        case 2:
          filtersFromHash = _context8.sent;
          minCredits = filtersFromHash.min_credits, maxCredits = filtersFromHash.max_credits;
          creditsRangeValue = getCreditsFilterValue(minCredits, maxCredits);
          filterOptions = {
            value: creditsRangeValue,
            valueFilter: true
          };
          _context8.next = 8;
          return put(addFilter(CREDITS, [], undefined, filterOptions));

        case 8:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
export function doLoadDate() {
  var _ref6, dateFilter, _ref7, date;

  return regeneratorRuntime.wrap(function doLoadDate$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return select(selectSearchFilters);

        case 2:
          _ref6 = _context9.sent;
          dateFilter = _ref6.date;

          if (!(dateFilter && dateFilter.value)) {
            _context9.next = 6;
            break;
          }

          return _context9.abrupt("return");

        case 6:
          _context9.next = 8;
          return select(selectFiltersFromSearchResults);

        case 8:
          _ref7 = _context9.sent;
          date = _ref7.date;
          _context9.next = 12;
          return put(addFilter(DATE, [], undefined, {
            valueFilter: true,
            value: date
          }));

        case 12:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}
export function doLoadTime() {
  var _ref8, time, _ref9, ft, tt;

  return regeneratorRuntime.wrap(function doLoadTime$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return select(selectSearchFilters);

        case 2:
          _ref8 = _context10.sent;
          time = _ref8.time;

          if (!(time && time.value)) {
            _context10.next = 6;
            break;
          }

          return _context10.abrupt("return");

        case 6:
          _context10.next = 8;
          return select(selectFiltersFromSearchResults);

        case 8:
          _ref9 = _context10.sent;
          ft = _ref9.ft;
          tt = _ref9.tt;
          _context10.next = 13;
          return put(addFilter(TIME, TIME_OPTIONS, undefined, {
            valueFilter: true,
            value: (ft || tt) && "".concat(ft, "-").concat(tt)
          }));

        case 13:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}
export function getDefaultResultType() {
  var isUserLoggedIn, activeUrl, _ref10, resultTypeFromHash;

  return regeneratorRuntime.wrap(function getDefaultResultType$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return select(isLoggedIn);

        case 2:
          isUserLoggedIn = _context11.sent;
          _context11.next = 5;
          return select(selectActiveUrl);

        case 5:
          activeUrl = _context11.sent;

          if (!(activeUrl === SEARCH_PATH)) {
            _context11.next = 8;
            break;
          }

          return _context11.abrupt("return", isUserLoggedIn ? DEFAULT_RESULT_TYPE_LOGGED_IN : DEFAULT_RESULT_TYPE_LOGGED_OUT);

        case 8:
          if (!isUserLoggedIn) {
            _context11.next = 14;
            break;
          }

          _context11.next = 11;
          return select(selectFiltersFromSearchResults);

        case 11:
          _ref10 = _context11.sent;
          resultTypeFromHash = _ref10.result_type;
          return _context11.abrupt("return", resultTypeFromHash || DEFAULT_RESULT_TYPE_LOGGED_IN);

        case 14:
          return _context11.abrupt("return", DEFAULT_RESULT_TYPE_LOGGED_OUT);

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}
export function getResultType() {
  var searchFilters, selectedResultType, defaultResultType;
  return regeneratorRuntime.wrap(function getResultType$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return select(filterSetFilters, SEARCH);

        case 2:
          searchFilters = _context12.sent;
          selectedResultType = deepExtract("".concat(RESULT_TYPE, ".value"), searchFilters); // If the user selected a result type explicitly, use that

          if (!selectedResultType) {
            _context12.next = 6;
            break;
          }

          return _context12.abrupt("return", selectedResultType);

        case 6:
          _context12.next = 8;
          return call(getDefaultResultType);

        case 8:
          defaultResultType = _context12.sent;
          return _context12.abrupt("return", defaultResultType);

        case 10:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}
export function doLoadResultType() {
  var resultType;
  return regeneratorRuntime.wrap(function doLoadResultType$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return call(getDefaultResultType);

        case 2:
          resultType = _context13.sent;
          _context13.next = 5;
          return put(addFilter(RESULT_TYPE, [], undefined, {
            exclusive: true,
            value: resultType
          }));

        case 5:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}
export function doSetupFilters() {
  return regeneratorRuntime.wrap(function doSetupFilters$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return put(setFilteringDisabled(true));

        case 2:
          _context14.next = 4;
          return call(doLoadVerticals);

        case 4:
          _context14.next = 6;
          return all([call(doLoadResultType), call(doLoadActivity), call(doLoadAmenity), call(doLoadLevel), call(doLoadDate), call(doLoadTime), call(doLoadRadius), call(doLoadCredits)]);

        case 6:
          _context14.next = 8;
          return put(setFilteringDisabled(false));

        case 8:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}
export function watchFilters() {
  return regeneratorRuntime.wrap(function watchFilters$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return fork(takeLatest, LOAD_VERTICALS, doLoadVerticals);

        case 2:
          _context15.next = 4;
          return fork(takeLatest, LOAD_ACTIVITY, doLoadActivity);

        case 4:
          _context15.next = 6;
          return fork(takeLatest, LOAD_AMENITY, doLoadAmenity);

        case 6:
          _context15.next = 8;
          return fork(takeLatest, LOAD_LEVEL, doLoadLevel);

        case 8:
          _context15.next = 10;
          return fork(takeLatest, LOAD_DATE, doLoadDate);

        case 10:
          _context15.next = 12;
          return fork(takeLatest, LOAD_TIME, doLoadTime);

        case 12:
          _context15.next = 14;
          return fork(takeLatest, LOAD_RESULT_TYPE, doLoadResultType);

        case 14:
          _context15.next = 16;
          return fork(takeLatest, setupFilters().type, doSetupFilters);

        case 16:
          _context15.next = 18;
          return fork(takeLatest, LOAD_RADIUS, doLoadRadius);

        case 18:
          _context15.next = 20;
          return fork(takeLatest, LOAD_CREDITS, doLoadCredits);

        case 20:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}